import { Component, inject, Input, OnInit, Optional } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { CareplusNewCustomer } from "src/models/careplus-new-customer";
import { CareplusAgencyService } from "src/services/careplus-agency-service";
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

@Component({
  selector: "app-payment-log-detail",
  templateUrl: "./payment-log-detail.component.html",
  styleUrls: ["./payment-log-detail.component.css"],
})
export class PaymentLogDetailComponent implements OnInit {
  private _router = inject(Router);
  private _agencyService = inject(CareplusAgencyService);

  @Input() customers: CareplusNewCustomer[] = [];
  @Input() batchId: number | null = null;

  public dialogData = inject(MAT_DIALOG_DATA, { optional: true });
  public dialogRef = inject(MatDialogRef<PaymentLogDetailComponent>, {
    optional: true,
  });

  isLoading = false;
  dataSource = new MatTableDataSource<CareplusNewCustomer>([]);
  displayedColumns: string[] = [
    "id",
    "firstName",
    "lastName",
    "countryCode",
    "phoneNumber",
    "gender",
    "dateOfBirth",
    "email",
  ];

  ngOnInit() {
    if (this.dialogData && this.dialogData.batchId) {
      this.batchId = this.dialogData.batchId;
    }

    if (this.batchId) {
      this.fetchBatchCustomers();
    } else {
      this.dataSource.data = this.customers || [];
    }
  }

  fetchBatchCustomers() {
    if (!this.batchId) {
      return;
    }

    this.isLoading = true;

    this._agencyService.getBatchDetail(this.batchId).subscribe({
      next: (res) => {
        this.dataSource.data = res?.customers || [];
        this.isLoading = false;
      },
      error: () => {
        this.dataSource.data = [];
        this.isLoading = false;
      },
    });
  }

  close() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
